import api, { apiPrefix } from './Api';
import {
  SliderSlide,
  sliderSlideFromResponse,
} from '../interfaces/Slider/SliderSlide';

const sliderApiPrefix = `${apiPrefix}/sliders`;

export const getSliderSlides = async (): Promise<SliderSlide[]> => {
  const response = await api.get(sliderApiPrefix);

  return (response.data?.data ?? []).map(sliderSlideFromResponse);
};
